
export const categories = [
  {
    id: 'beverages',
		label: "Getränke",
		color: "#E99575",
	},
  {
    id: "dairy & eggs",
		label: "Milchprodukte & Eier",
		color: "#FBE872",
	},
	{
    id: "fish & seafood",
		label: "Fisch",
		color: "#74BDE0",
	},
  {
    id: "fruits & berries",
		label: "Obst",
		color: "#7FAAE9",
	},
  {
    id: "legumes",
		label: "Hülsenfrüchte",
		color: "#E99575",
	},
  {
    id: "meat",
		label: "Fleisch",
		color: "#E98791",
	},
  { 
    id: "nuts & seeds",
		label: "Nüsse",
		color: "#D4A187",
	},
  {
    id: "spices & condiments",
		label: "Gewürze & Soßen",
		color: "#7FAAE9",
	},
  {
    "id": "starches & bread",
		label: "Getreideprodukte",
		//color: "#E1CF74",
    color: '#dec373',
	},
  {
    id: "vegetables & mushrooms",
		label: "Gemüse",
		color: "#6FE9AA",
	},
  {
    id: "vegetable oils",
		label: "Pflanzliche Fette",
		color: "#a9e0d6",
	},
];

export const categoriesById = {};

categories.forEach((c) => {
  categoriesById[c.id] = c;
});


